import {
  completeQueryResult,
  hasCompleteQueryData,
  throwOnQueryError,
} from 'ZalamoLibrary/src/lib/core/graphql/complete-query-data';

import { filter, map, pipe, switchMap, tap } from 'rxjs';

import { Injectable } from '@angular/core';

import { OrganizationService } from 'ZalamoLibrary/src/lib/core/organizations/organization.service';
import { GetInvoiceDetailsGQL } from '../../../../../photographer-panel/src/graphql';
import { removeTypename } from 'ZalamoLibrary/src/lib/core/graphql/helpers';

@Injectable({
  providedIn: 'root',
})
export class OrganizationInvoiceDetailsService {
  constructor(
    private organizationService: OrganizationService,
    private getInvoiceDetailsGQL: GetInvoiceDetailsGQL,
  ) {}

  isValid() {
    return this.details().pipe(
      tap((x) => console.log(x)),
      map((invoiceDetails) =>
        Object.values(invoiceDetails).every((v) => v !== null),
      ),
    );
  }
  details() {
    return this.organizationService.getCurrentOrganization().pipe(
      switchMap((organizationId) =>
        this.getInvoiceDetailsGQL
          .watch({ variables: { organizationId } })
          .valueChanges.pipe(
            throwOnQueryError,
            filter(hasCompleteQueryData),
            map((apolloQueryResult) => {
              const {
                data: {
                  me: { invoiceDetails },
                },
              } = completeQueryResult(apolloQueryResult);
              return removeTypename(invoiceDetails);
            }),
          ),
      ),
    );
  }
}
